<script setup lang="ts">
import { CfgPreloader } from '@cfgtech/ui';

defineProps<{
  isLoading?: boolean;
}>();

const { t } = useI18n();

const dataLayer = useDataLayer();

const steps = [{
  key: 'search',
  name: t('orders.create.layout.steps.search'),
  route: '/orders/create',
  closeUrl: '/portfolio',
  back: false,
}, {
  key: 'compare',
  name: t('orders.create.layout.steps.compare'),
  route: '/orders/create/base/:id()',
  closeUrl: false,
  back: true,
}, {
  key: 'form',
  name: t('orders.create.layout.steps.form'),
  route: '/orders/create/parameters/:id()',
  closeUrl: false,
  back: true,
}, {
  key: 'success',
  name: t('orders.create.layout.steps.success'),
  route: '/orders/create/success',
  closeUrl: '/portfolio',
  back: false,
}];

function handlePreviousStep(stepKey: string) {
  switch (stepKey) {
    case 'compare':
      dataLayer.backManualAdd(LocationsEnum.ISSUE_ADD_COMPARISON);
      break;
    case 'form':
      dataLayer.backManualAdd(LocationsEnum.ISSUE_ADD_INVESTMENT_DATA);
      break;

    default:
      break;
  }
}

function handleCloseUrl(stepKey: string) {
  if (stepKey === 'success') {
    dataLayer.closeConfirmationScreen(LocationsEnum.ISSUE_ADDED_MANUALLY_SUCCESS);
  }
}
</script>

<template>
  <div>
    <AppNavbarStepper
      :steps="steps"
      @close:url="handleCloseUrl"
      @previous:step="handlePreviousStep"
    />

    <template v-if="!isLoading">
      <main class="container grow px-3 pt-5 lg:p-5 lg:pt-6">
        <slot />
      </main>
    </template>

    <template v-else>
      <div class="flex h-screen flex-col items-center justify-center gap-y-10">
        <CfgPreloader class="text-brand" />

        <slot name="loadingText" />
      </div>
    </template>
  </div>
</template>
